import store from '@/store'

let role = []

export const initPermissions = () => {
  const profile = store.state.profile.profile
  role = {
    admin: profile.type_user === 'Admin',

    // ВЛ
    directorLaboratory: profile.type_user === 'Director laboratory',
    expertLaboratory: profile.type_user === 'Expert laboratory',
    sectionChiefLaboratory: profile.type_user === 'Section cheif laboratory',
    managerLaboratory: profile.type_user === 'Manager laboratory',

    // OC
    auditorCertification: profile.type_user === 'Auditor certification',
    directorCertification: profile.type_user === 'Director certification',

    guestUser: profile.type_user === 'Guest'
  }
}

export const access = typeAccess => {
  if (typeAccess === 'public') {
    return true
  }

  switch (typeAccess) {
    // statement
    case 'statementView':
      return true
    case 'clientStatementView':
      return role.directorCertification || role.auditorCertification ||
        role.directorLaboratory || role.sectionChiefLaboratory || role.managerLaboratory
    case 'statementCreate':
    case 'useActionsClientStatement':
      return role.auditorCertification || role.managerLaboratory
    case 'clientTechnicalControlView':
      return role.directorLaboratory || role.sectionChiefLaboratory || role.managerLaboratory
    case 'statementActionAuditorCertification':
      return role.auditorCertification
    case 'statementActionAuditorAndManager':
      return role.auditorCertification || role.managerLaboratory
    case 'statementActionDirectorCertification':
      return role.directorCertification
    case 'chooseOrganization':
      return role.auditorCertification || role.managerLaboratory
    case 'setCategory':
      return role.auditorCertification || role.managerLaboratory
    case 'viewClientInfoList':
      return role.directorLaboratory || role.expertLaboratory || role.sectionChiefLaboratory
    case 'viewClientInfoCard':
      return role.directorCertification || role.auditorCertification || role.managerLaboratory
        || role.expertLaboratory
    case 'statementActionManagerLaboratory':
    case 'useActionsClientTechnicalStatement':
      return role.managerLaboratory
    case 'auditorCertification':
      return role.auditorCertification

    case 'technicalControlView' :
      return role.managerLaboratory || role.expertLaboratory ||
        role.sectionChiefLaboratory || role.directorLaboratory
    case 'technicalControlStatementCreate' :
      return role.managerLaboratory || role.expertLaboratory
    case 'technicalControlClientInfoCard':
      return role.directorLaboratory || role.managerLaboratory
    case 'statementNewKtz':
      return role.directorCertification || role.auditorCertification

    //branch
    case 'measuringLaboratoryView':
      return role.directorLaboratory
    case 'branchView':
      return role.sectionChiefLaboratory || role.directorLaboratory

    case 'branchCreate':
      return role.directorLaboratory
    case 'branchUpdate':
      return role.sectionChiefLaboratory || role.directorLaboratory

    //inspection
    case 'inspectionCreate':
      return role.expertLaboratory
    case 'inspectionCard':
      return true
    case 'canPrintInspectionDocument':
      return role.managerLaboratory
    //role.directorLaboratory || role.auditorCertification ||
    // role.auditorCertification || role.directorCertification
    case 'uploadProofBase':
      return role.expertLaboratory

    //re-equipment
    case 'reEquipmentView':
      return role.expertLaboratory

    //measurements
    case 'measurementsView':
      return role.directorLaboratory || role.expertLaboratory

    //settings
    case 'settings':
      return true
    case 'canAddAndRemoveKey':
      return role.directorLaboratory || role.expertLaboratory || role.sectionChiefLaboratory ||
        role.managerLaboratory || role.auditorCertification || role.directorCertification

    case 'auditorActions':
      return role.auditorCertification || role.managerLaboratory
    case 'directorCertificationActions':
      return role.directorCertification
    case 'directorLaboratoryActions':
      return role.directorLaboratory
    case 'sectionChiefLaboratoryActions':
      return role.sectionChiefLaboratory
    case 'expertLaboratoryActions':
      return role.expertLaboratory

    // account OC
    case 'guestUser':
      return role.guestUser
    case 'viewContracts':
      return role.directorCertification

    // users
    case 'canCreateChief':
      return role.directorLaboratory
    case 'canCreateExpert':
      return role.directorLaboratory || role.sectionChiefLaboratory
    case 'canCreateManager':
      return role.directorLaboratory || role.sectionChiefLaboratory
    case 'canResetUserPassword':
      return role.directorLaboratory || role.sectionChiefLaboratory

    // contract
    case 'canViewContract':
      return role.directorCertification || role.directorLaboratory
    case 'viewContractLabInfo':
      return role.directorCertification
    case 'viewContractOCInfo':
      return role.directorLaboratory

    case 'viewCharacteristic':
      return role.auditorCertification || role.directorCertification
    case 'setCharacteristic':
      return role.auditorCertification
    case 'signCertificateManual':
      return role.directorCertification

    default:
      return false
  }

  // if (typeof typeAccess === 'object') {
  //   return typeAccess.some(p => profile.permissions.includes(p))
  // }
  // else return profile.permissions.includes(typeAccess)
}
